module.exports = __webpack_public_path__ + "static/media/close.e95db44f.svg";